export type Percent = number & {
    [K in {readonly Percent: unique symbol}['Percent']]: never;
};

export function Percent(value: number): Percent {
    if (Percent.is(value)) {
        return value;
    }
    if (import.meta.env.DEV) {
        console.trace(`%cNot a Percent: ${value}`, 'color:red');
    }
    return Percent.clamp(value);
}

export namespace Percent {
    export function is(value: unknown): value is Percent {
        if (typeof value !== 'number') {
            return false;
        }
        return 0 <= value && value <= 1;
    }

    export function assert(value: number): asserts value is Percent {
        if (!is(value)) {
            throw new Error(`percent must be float, got ${value}`);
        }
    }

    export function clamp(value: number): Percent {
        return Math.max(0, Math.min(value, 1)) as Percent;
    }

    export function format(value: Percent) {
        if (value < 0.01) {
            return '<1%';
        }
        if (value >= 0.99 && value !== 1) {
            return '>99%';
        }
        return `${Math.round(value * 100)}%`;
    }
}

export namespace Percent {
    export const zero = Percent(0.0);
    export const hundred = Percent(1.0);
}
